import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { history } from '../store';

// actions
import { logoutUser } from '../actions/user';
import { sofologistLogout } from '../actions/sofologist';

// components
import GhostButton from '../parts/GhostButton';
import TextCTA from './buttons/TextCTA';

class _SofologistHeader extends Component {

  constructor(props) {
    super(props);
    this.handleNextCustomer = this.handleNextCustomer.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleNextCustomer() {
    this.props.logoutUser();
    history.push('./admin');
  }

  handleLogout() {
    this.props.sofologistLogout();
    history.push('./admin');
  }

  render() {
    const { sofologist, userId } = this.props;
    if (!sofologist.Authorized) return null;

    return (
      <div
        className="sofologist__header u-padding-tiny u-blue-bg--contrast u-text-center u-flex u-flex-justify-space-between u-flex-wrap u-flex-align-items-center"
      >

        <TextCTA
          extraClass="c-logout__btn"
          text="logout"
          onBtnClick={this.handleLogout}
        />

        {userId && (
          <div
            className="u-padding-y-micro sofologist__header__status"
            style={{ display: 'inline-block' }}
          >
            - {sofologist.location} - {sofologist.login}
            <div className="u-padding-top-tiny"> on behalf of - {userId}</div>
          </div>)}

        <GhostButton
          text="Next Customer"
          onBtnClick={this.handleNextCustomer}
        />

      </div>
    );
  }
}


const mapStateToProps = state => ({
  sofologist: state.sofologist,
  userId: state.user.userId
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logoutUser, sofologistLogout
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(_SofologistHeader);



// WEBPACK FOOTER //
// ./src/layout/SofologistHeader.js